import { useEffect, useState } from 'react'
import { getLocalApiUrl, authFetch } from '../config/api'

const cache = new Map()

export function clearScreenHelpCache(screenKey) {
  if (screenKey) cache.delete(screenKey)
  else cache.clear()
}

/**
 * Load published help for a screen. Uses HEAD then GET; caches per session.
 */
export function useScreenHelp(screenKey) {
  const [state, setState] = useState(() => ({
    loading: !!screenKey,
    hasHelp: false,
    data: screenKey && cache.has(screenKey) ? cache.get(screenKey) : null,
  }))

  useEffect(() => {
    if (!screenKey) {
      setState({ loading: false, hasHelp: false, data: null })
      return undefined
    }

    if (cache.has(screenKey)) {
      const cached = cache.get(screenKey)
      setState({ loading: false, hasHelp: !!cached, data: cached })
      return undefined
    }

    let cancelled = false
    setState((s) => ({ ...s, loading: true }))

    ;(async () => {
      try {
        const enc = encodeURIComponent(screenKey)
        const url = getLocalApiUrl(`/api/help/screens/${enc}`)
        const head = await authFetch(url, { method: 'HEAD' })
        if (!head.ok) {
          cache.set(screenKey, null)
          if (!cancelled) setState({ loading: false, hasHelp: false, data: null })
          return
        }
        const r = await authFetch(url)
        const j = await r.json()
        const data = r.ok && j.success ? j.data : null
        cache.set(screenKey, data)
        if (!cancelled) setState({ loading: false, hasHelp: !!data, data })
      } catch {
        cache.set(screenKey, null)
        if (!cancelled) setState({ loading: false, hasHelp: false, data: null })
      }
    })()

    return () => {
      cancelled = true
    }
  }, [screenKey])

  return state
}
